import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import type { IShiftVto } from '@/components/agent/my-schedule/shifts/types';
import type { Hue } from '@/types/styles';

import { Vto, VtoAccepted } from '@/assets/icons';
import { CrossedBackgroud } from '@/assets/images';
import { colors } from '@/styles/colors';
import { ShiftAssignStatus } from '@/store/enums';
import { BaseShift, ShiftVtoModal } from '@/components/agent/my-schedule';

const ShiftVto = ({
  block,
  contract,
  blockColor,
  modal,
  onClick,
  isDlsBlocked,
  day,
}: IShiftVto): React.ReactElement => {
  const { t } = useTranslation();
  const isVtoTaken = block.shiftAssnStatus === ShiftAssignStatus.vtoAccepted;

  const shiftModal = useCallback(
    (parentRef, ref) =>
      !isVtoTaken ? (
        <ShiftVtoModal contract={contract} blockColor={blockColor} block={block} ref={ref} parentRef={parentRef} />
      ) : (
        <></>
      ),
    [block, blockColor, contract, isVtoTaken],
  );

  return (
    <ShiftContainer
      className="shift-vto"
      blockColor={blockColor}
      block={block}
      contract={contract}
      modal={modal ? modal : shiftModal}
      isVtoTaken={isVtoTaken}
      icon={isVtoTaken ? VtoAccepted : Vto}
      onClick={onClick}
      isDlsBlocked={isDlsBlocked}
      day={day}
    >
      {t`mySchedule.vtoBaseShiftModal.buttonAcceptVto`}
    </ShiftContainer>
  );
};

export { ShiftVto };

const ShiftContainer = styled(BaseShift)<{
  isVtoTaken: boolean;
  blockColor: Hue;
}>`
  color: ${props => colors[props.blockColor]['c800']};

  &&& {
    ${props =>
      props.isVtoTaken &&
      `
      background-image: url(${CrossedBackgroud});
      background-color: ${colors[props.blockColor]['c500']};
      color: #fff;
      cursor: default;

      .schedule-focused & {
        background-color: ${colors[props.blockColor]['c400']};
      }

      .title-icon {
        background-color: #fff;
      }
    `}
  }
`;
